import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { ChipFill, Body1 } from '@sbol/nova';
import { clsx } from 'clsx';
import type { AnswersViewProps } from '../AnswersView';
import type { MatrixModel } from './MatrixModel';
import styles from './Matrix.module.scss';

export const Matrix: FC<AnswersViewProps<MatrixModel>> = observer(({ questionModel }) => {
  const { rows, cols, handleClickChip, disabled } = questionModel;

  return (
    <div>
      {rows.map((row) => {
        return (
          <div key={row.id} className={styles.Row}>
            <Body1 className={styles.header_text}>{row.header_text}</Body1>
            <div className={clsx(styles.ChipContainer, questionModel.isRatingScale10 && styles.rating_scale_10)}>
              {cols.map((col) => {
                return (
                  <ChipFill
                    key={col.id}
                    disabled={disabled}
                    className={styles.Chip}
                    title={col.header_text}
                    data-row-id={row.id}
                    data-col-id={col.id}
                    onClick={!disabled ? handleClickChip : undefined}
                    selected={questionModel.isAnswerSelected(row.id, col.id)}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
});
